import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Modal from '../../common/Modal';
import ServiceSongList from '../../ServiceSongList';
import theme from '../../../utils/theme';
import { getRemainingDays, getRemainingDaysLabel } from '../../../utils/utilities';
import { JUMP_TO_MY_PART } from '../../../hooks/useJumpToMyPart';

import './AssignedPartsModal.scss';

// Every upcoming service the user has a part in, each with the songs they're on and their parts in each,
// a tap away from the part: a tag for that one, the rest of the row for the first
const AssignedPartsModal = ({ isOpen, onClose, assigned }) => {
  const history = useHistory();
  const { t } = useTranslation();

  const openPart = (service, i, partId) => {
    history.push({
      pathname: `/view/service/${service._id}`,
      hash: i === 0 ? '' : `#${i + 1}`,
      state: { [JUMP_TO_MY_PART]: partId },
    });
    onClose();
  };

  const renderParts = (service) => (entry) => (
    <span className="parts">
      {entry.parts.map((part) => (
        <button
          key={part.id}
          type="button"
          className={theme.renderPartColor(part.name, 'part')}
          onClick={(e) => {
            // The row would open the song at its first part instead
            e.stopPropagation();
            openPart(service, entry.i, part.id);
          }}
        >
          {`${t(`parts.${part.name}`, { defaultValue: part.name })} ${part.number}`.trim()}
        </button>
      ))}
    </span>
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={t('dialogs.assignedParts.title')}>
      <div className="AssignedPartsModal">
        {assigned.map(({ service, entries }) => (
          <section key={service._id} className="group">
            <h4 className="heading">
              <span className="title">{service.title}</span>
              <span className="date">{getRemainingDaysLabel(getRemainingDays(service.date))}</span>
            </h4>
            <ServiceSongList
              entries={entries}
              onSelect={(i) => openPart(service, i, entries.find((entry) => entry.i === i).parts[0].id)}
              renderMeta={renderParts(service)}
            />
          </section>
        ))}
      </div>
    </Modal>
  );
};

AssignedPartsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  // As getAssignedServices gives them
  assigned: PropTypes.arrayOf(
    PropTypes.shape({
      service: PropTypes.object.isRequired,
      entries: PropTypes.arrayOf(
        PropTypes.shape({
          song: PropTypes.object.isRequired,
          i: PropTypes.number.isRequired,
          parts: PropTypes.arrayOf(
            PropTypes.shape({
              id: PropTypes.string.isRequired,
              name: PropTypes.string,
              number: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
            }),
          ).isRequired,
        }),
      ).isRequired,
    }),
  ).isRequired,
};

export default AssignedPartsModal;
